<hbox class="event font-small" on:click on:click={onSelect} on:dblclick={onOpen}
  title={eventAsText}>
  {#if !$event.allDay && !isContinued}
    <hbox class="time">
      {startTime}
    </hbox>
  {/if}
  <hbox class="title">{$event.title}</hbox>
</hbox>

<script lang="ts">
  import type { Event } from "../../../logic/Calendar/Event";
  import { openEventFromOtherApp } from "../open";
  import { selectedEvent } from "../selected";
  import { getDurationString } from "../../Util/date";
  import { getDateTimeFormatPref } from "../../../l10n/l10n";

  export let event: Event;
  /** Time where the cell (not the event) starts */
  export let start: Date;

  $: startTime = $event.startTime.toLocaleString(getDateTimeFormatPref(), {
    hour: "numeric",
    minute: $event.startTime.getMinutes() != 0 ? "2-digit" : undefined,
  });
  $: eventAsText = ($event.allDay ? "" : `${startTime} – ${getDurationString(event.endTime.getTime() - event.startTime.getTime())}\n`) +
     event.title +
     (event.participants.isEmpty ? "" : "\n" + event.participants.getIndexRange(0, 4).map(person => person.name).join(", "));
  $: isContinued = $event.startTime < start;

  function onSelect() {
    $selectedEvent = event;
  }

  function onOpen() {
    $selectedEvent = event;
    openEventFromOtherApp(event, true);
  }
</script>

<style>
  .event {
    background-color: var(--color);
    color: lch(from var(--color) calc((49.44 - l) * infinity) 0 0);
    padding-inline-start: 4px;
  }
  @media (prefers-color-scheme: dark) {
    .event {
      background-image:
        linear-gradient(var(--color), var(--color)),
        linear-gradient(#000000AA, #000000AA);
      background-blend-mode: overlay;
      background-color: unset;
      color: unset;
    }
  }
  .event:hover {
    background-color: #20AF9E70;
  }
  .time {
    margin-inline-end: 4px;
    font-weight: 600;
  }
  :global(.cancelled) .time,
  :global(.cancelled) .title {
    text-decoration: line-through;
  }
</style>
